import Vue from 'vue'
import Router from 'vue-router'
import Categories from './views/Categories'
import Sections from './views/Sections'
import BaseWords from './views/BaseWords'
import Login from './views/Login'
import Languages from './views/Languages'
import Sources from './views/Sources'
import Translations from './views/Translations'
import TranslatedSections from './views/TranslatedSections'
import TranslatedCategories from './views/TranslatedCategories'
import Alphabet from './views/Alphabet'
import TransliteratedAlphabet from './views/TransliteratedAlphabet'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/sources/:sourceDictionaryId/words',
      name: 'sources',
      component: Sources
    },
    {
      path: '/sources/:sourceDictionaryId/alphabet',
      name: 'alphabet',
      component: Alphabet
    },
    {
      path: '/dictionary/:dictionaryId/words',
      name: 'translations',
      component: Translations
    },
    {
      path: '/dictionary/:dictionaryId/sections',
      name: 'translated-sections',
      component: TranslatedSections
    },
    {
      path: '/dictionary/:dictionaryId/categories',
      name: 'translated-categories',
      component: TranslatedCategories
    },
    {
      path: '/dictionary/:dictionaryId/alphabet',
      name: 'transliterated-alphabet',
      component: TransliteratedAlphabet
    },
    {
      path: '/base-words',
      name: 'base-words',
      component: BaseWords,
      meta: { sourceDictionaryId: 'en' }
    },
    {
      path: '/sources/:sourceDictionaryId/categories',
      name: 'categories',
      component: Categories
    },
    {
      path: '/sources/:sourceDictionaryId/sections',
      name: 'sections',
      component: Sections
    },
    {
      path: '/languages',
      name: 'languages',
      component: Languages
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    }
  ]
})
